import { Directive, Optional, TemplateRef } from '@angular/core';
import { DatalistFooterComponent } from './datalist-footer.component';
import { DatalistComponent } from './datalist.component';

@Directive({ selector: '[mriDataListActionsBtn]', standalone: true })
export class DatalistActionsBtnDirective {
  constructor(
    itemTemplate: TemplateRef<never>,
    @Optional() footer: DatalistFooterComponent,
    @Optional() datalist: DatalistComponent
  ) {
    if (footer) {
      footer.actionsBtnTemplate = itemTemplate;
    }
    if (datalist) {
      datalist.actionsBtnTemplate = itemTemplate;
    }
  }
}
